import MakeTag from "../makeTag/MakeTag";
export default function MultPratformTag() {
  return (<>
    <MacTag />
    <MakeTag tagText="Linux" color="#686868" />
    <WindowsTag />
    <MakeTag tagText="Android" color="#9fc037" />
  </>);
}

export function WindowsTag() {
  return (<>
    <MakeTag tagText="Windows" color="#017fd5" />
  </>);
}
export function MacTag() {
  return (<>
    <MakeTag tagText="MacOS" color="#fff" />
  </>);
}

